import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import IdleLock from './IdleLock';

export default function Layout() {
  return (
    <div className="layout">
      <Sidebar />
      <TopBar />
      <main className="main">
        <Outlet />
      </main>
      {/* Inactivity lock — hides the portal after 5 idle minutes and
          requires Microsoft password re-verification to resume. */}
      <IdleLock />
    </div>
  );
}
